import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/_nuxt3-static/logos/logo.svg")